import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { ErrorInterceptor } from '@shared/interceptors/error.interceptor';
import { HeadersInterceptor } from '@shared/interceptors/headers.interceptor';
import { CustomLoaderService } from '@shared/translation';
import { RxStompService } from '@stomp/ng2-stompjs';
import { WINDOW_PROVIDERS } from '@shared/services/window.service';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '@shared/material.module';
import { MainSharedModule } from '@shared/main-shared.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '@env/environment';
import { PreloaderPageComponent } from '@shared/pages/preloader-page/preloader-page.component';
// import { UpdateService } from '@shared/services/update.service';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';


@NgModule({
  declarations: [
    AppComponent,
    MainLayoutComponent,
    PreloaderPageComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule.withServerTransition({appId: 'serverApp'}),
    AppRoutingModule,
    MaterialModule,
    MainSharedModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {provide: TranslateLoader, useClass: CustomLoaderService}
    }),
    RouterModule,
    // ServiceWorkerModule.register('ngsw-worker.js', {
    //   enabled: environment.production,
    //   registrationStrategy: 'registerWhenStable:30000'
    // })
  ],
  providers: [
    // UpdateService,
    {provide: HTTP_INTERCEPTORS, useClass: HeadersInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
    // { provide: 'Window',  useValue: window },
    WINDOW_PROVIDERS,
    {provide: RxStompService},
    provideHttpClient(withInterceptorsFromDi()),
  ]
})
export class AppModule {
}
